<nz-tabset [nzSelectedIndex]="selectedTabIndex">
  <ng-container *ngFor="let tabGroup of tabGroupsInternal; let groupIndex = index;">
    <ng-container *ngFor="let tab of tabGroup; let tabIndex = index;">
      <nz-tab>
        <a nz-tab-link [ngClass]="{'tab-group-start': groupIndex > 0 && tabIndex === 0 }" (click)="onTabClick(tab.key)">
          <span>{{tab.text}}</span>
          <div *ngIf="tab.infoBadge !== undefined" class="info-badge">{{tab.infoBadge}}</div>
        </a>
      </nz-tab>
    </ng-container>
  </ng-container>
</nz-tabset>

<!-- Copied into the appropriate locations AfterViewInit -->
<nz-divider #sampleDivider nzType="vertical" class="d-none-imp"></nz-divider>
